module.exports = __webpack_public_path__ + "img/success-send-bill.5946e741.svg";